<template>
	<div class="filter support">
		<h1 class="thermo">Type</h1>
		<div class="filter-item">
			<span @click="setType('all')">Alle</span>
			<ToggleField
				type="radio"
				name="type"
				:checked="currentType === 'all'"
				@change="setType('all')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setType('canceled-execution')">Afgebroken uitvoering</span>
			<ToggleField
				type="radio"
				name="type"
				:checked="currentType === 'canceled-execution'"
				@change="setType('canceled-execution')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setType('support')">Support ticket</span>
			<ToggleField
				type="radio"
				name="type"
				:checked="currentType === 'support'"
				@change="setType('support')"
			/>
		</div>

		<h1 class="thermo">Filter</h1>
		<div class="filter-item">
			<span @click="setFilter('open')">Openstaand</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'open'"
				@change="setFilter('open')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setFilter('new')">Nieuw</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'new'"
				@change="setFilter('new')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setFilter('in_progress')">In behandeling</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'in_progress'"
				@change="setFilter('in_progress')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setFilter('in_solution')">In oplossing</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'in_solution'"
				@change="setFilter('in_solution')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setFilter('external')">Externe partij</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'external'"
				@change="setFilter('external')"
			/>
		</div>
		<div class="filter-item">
			<span @click="setFilter('finishing')">Af te ronden</span>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'finishing'"
				@change="setFilter('finishing')"
			/>
		</div>

		<div style="display: flex; justify-content: space-between; margin-bottom: 0.5em; margin-top: 1em;">
			<h1 class="thermo">Afgerond</h1>
			<ToggleField
				type="radio"
				name="filter"
				:checked="currentFilter === 'finished'"
				@change="setFilter('finished')"
			/>
		</div>
		<div class="historic-input-container" v-if="currentFilter === 'finished'">
			Van <DateField v-model="historicFromDate" @change="emitFilterChange"></DateField>
			T/m <DateField v-model="historicTillDate" @change="emitFilterChange"></DateField>
		</div>
	</div>
</template>

<script>
import DateField from "@/components/DateField.vue";
import ToggleField from "@/components/ToggleField.vue";
import moment from "moment";

export default {
	components: {
		DateField,
		ToggleField,
	},

	props: {
		filter: String
	},

	watch: {
		filter() {
			if (this.filter === this.currentFilter) {
				return;
			}

			this.currentFilter = this.filter;
			this.emitFilterChange();
		}
	},

	data() {
		return {
			historicFromDate: moment().subtract(6, 'months').format('DD-MM-YYYY'),
			historicTillDate: moment().format('DD-MM-YYYY'),
			currentType: 'all',
			currentFilter: 'open'
		};
	},

	mounted() {
		this.emitFilterChange();
	},

	methods: {
		setType(type) {
			this.currentType = type;
			this.emitFilterChange();
		},

		setFilter(filter) {
			this.currentFilter = filter;
			this.emitFilterChange();
		},

		emitFilterChange() {
			this.$emit('filterChange', {
				filter: this.currentFilter,
				type: this.currentType,
				historicFromDate: this.historicFromDate,
				historicTillDate: this.historicTillDate
			});
		}
	}
};
</script>

<style scoped lang="scss">
	.filter-item {
		display: flex; justify-content: space-between; margin-bottom: 0.5em;
	}
</style>
